import { PropsWithChildren } from "react";
import {
  StyledLinkContainerTitle,
  StyledNavLinkContainer,
} from "./drawer.styles";
import { useDrawerContext } from "./DrawerContextProvider";

type DrawerSectionProps = PropsWithChildren<{
  title?: string;
}>;

export const DrawerSection = ({ children, title }: DrawerSectionProps) => {
  const { isDrawerOpen } = useDrawerContext();
  return (
    <StyledNavLinkContainer $isDrawerOpen={isDrawerOpen}>
      {title && isDrawerOpen && (
        <StyledLinkContainerTitle insensitive variant="h5">
          {title}
        </StyledLinkContainerTitle>
      )}
      {children}
    </StyledNavLinkContainer>
  );
};
